'use strict'

const cloneDeep_ = require('lodash/cloneDeep')
const noop_ = require('lodash/noop')

const addScopeToAllHandshakes = (handshakes, { componentId, itemId }) =>
  handshakes.map(handshake =>
    Object.assign({}, handshake, {
      controllerApi: handshake.controllerApi.inScope(componentId, itemId)
    })
  )

const createScopeUniqeId = (uniqueId, scopeId) =>
  [uniqueId, 'componentId', scopeId.componentId, 'itemId', scopeId.itemId].join(
    '_'
  )

module.exports = (
  createDataset,
  {
    controllerConfig,
    connections,
    wixDataProxy,
    wixSdk,
    errorReporter,
    platformUtilities,
    ravenProxy,
    errorBoundaries,
    uniqueId,
    services,
    schemaAPI,
    recordStoreServiceWrapper,
    fedopsLogger
  }
) => ({
  createDetailsScope: scopeId =>
    createDataset({
      controllerConfig,
      connections,
      wixDataProxy,
      firePlatformEvent: noop_,
      wixSdk,
      errorReporter,
      platformUtilities,
      ravenProxy,
      errorBoundaries,
      uniqueId: createScopeUniqeId(uniqueId, scopeId),
      isScoped: true,
      handshakes: addScopeToAllHandshakes(services().handshakes, scopeId),
      schemaAPI,
      recordStoreServiceWrapper,
      fedopsLogger
    }),
  createFixedItemScope: (scopeId, fixedItem) => {
    const newControllerConfig = cloneDeep_(controllerConfig)
    newControllerConfig.dataset.filter = wixDataProxy
      .filter()
      .eq('_id', fixedItem._id)
      ._build()

    return createDataset({
      controllerConfig: newControllerConfig,
      connections,
      wixDataProxy,
      firePlatformEvent: noop_,
      wixSdk,
      errorReporter,
      platformUtilities,
      prefetchedData: { items: [fixedItem], totalCount: 1 },
      ravenProxy,
      errorBoundaries,
      uniqueId: createScopeUniqeId(uniqueId, scopeId),
      isScoped: true,
      schemaAPI,
      recordStoreServiceWrapper,
      fedopsLogger
    })
  }
})



// WEBPACK FOOTER //
// ./dataset-controller/scopeFactory.js